
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import ContentSwitcher from '../../../components/docs/ContentSwitcher';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  noIndex: true,
  section: 'Bank Transfer (beta)',
  title: 'Reference',
  description: 'API reference for Bank Transfer (beta) endpoints',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Bank Transfer (beta) endpoints' subtitle='API Reference guide for the Bank Transfer (beta) product' mdxType="Header" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Initiate a bank transfer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/cancel`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cancel a bank transfer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve data about a bank transfer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Find bank transfers matching specified criteria`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/event/list`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve bank transfer events matching specified criteria`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/event/sync`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve bank transfer events after a given bank transfer event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/migrate_account`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create an Item to use with Bank Transfers from a known account number and routing number`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/bank_transfer/balance/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve the balance on your Plaid bank transfer account`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/bank_transfer/simulate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Simulate a bank transfer event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/bank_transfer/fire_webhook`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Simulate a Bank Transfers webhook`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#bank_transfers_events_update"
            }}><inlineCode parentName="a">{`BANK_TRANSFERS_EVENTS_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New bank transfer events available`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "bank_transfercreate"
    }}>{`/bank_transfer/create`}</h4>
    <Schema method='POST' route='/bank_transfer/create' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/create \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "idempotency_key": String,
   "access_token": String,
   "account_id": String,
   "type": String,
   "network": String,
   "amount": String,
   "iso_currency_code": String,
   "description": String,
   "ach_class": String,
   "user": {
     "legal_name": String,
     "email_address": String
   },
   "custom_tag": String,
   "metadata": {
     "specify_up_to_50_custom_field_names": String
   },
   "origination_account_id": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferCreateRequest(
    idempotency_key=BankTransferIdempotencyKey('random string'),
    access_token=access_token,
    account_id='BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
    type=BankTransferType('credit'),
    network=BankTransferNetwork('ach'),
    amount='1.00',
    iso_currency_code='USD',
    description='payment',
    user=BankTransferUser(legal_name='Firstname Lastname'),
    metadata=None,
    ach_class=ACHClass('ppd'),
    custom_tag='',
    origination_account_id = '11111111-1111-1111-1111-111111111111',
)
response = client.bank_transfer_create(request)
bank_transfer = response['bank_transfer']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferCreateRequest = {
  type: 'credit',
  network: 'ach',
  amount: '10.00',
  iso_currency_code: 'USD',
  description: 'payment',
  ach_class: 'ppd',
  user: {
    legal_name: 'First Lastname',
  },
  access_token: accessToken,
  idempotency_key: 'random string',
  account_id: 'BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp',
};
try {
  const response = await client.bankTransferCreate(request);
  const bank_transfer = response.data.bank_transfer;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferUser user = new BankTransferUser().legalName("First Last");
BankTransferCreateRequest request = new BankTransferCreateRequest()
  .accessToken(accessToken)
  .idempotencyKey("random string")
  .accountId("BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp")
  .type(BankTransferType.CREDIT)
  .network(BankTransferNetwork.ACH)
  .amount("1.00")
  .isoCurrencyCode("USD")
  .description("payment")
  .user(user)
  .achClass(ACHClass.PPD);
Response<BankTransferCreateResponse> response = client()
  .bankTransferCreate(request)
  .execute();
BankTransfer bankTransfer =
  response.body().getBankTransfer();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferCreateRequest.new(
  {
    idempotency_key: "random string",
    access_token: access_token,
    account_id: "BxBXxLj1m4HMXBm9WZZmCWVbPjX16EHwv99vp",
    type: Plaid::BankTransferType::CREDIT,
    network: Plaid::BankTransferNetwork::ACH,
    amount: "1.00",
    iso_currency_code: "USD",
    description: "plaid",
    ach_class: "ppd",
    user: {
      legal_name: "Firstname Lastname",
    },
  }
)
response = client.bank_transfer_create(request)
bank_transfer = response.bank_transfer
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferCreateRequest(
  "IDEMPOTENCY_KEY",
  "ACCESS_TOKEN",
  "ACCOUNT_ID",
  plaid.BANKTRANSFERTYPE_DEBIT,
  plaid.BANKTRANSFERNETWORK_ACH,
  "AMOUNT",
  "ISO_CURRENCY_CODE",
  "DESCRIPTION",
  *plaid.NewBankTransferUser("Firstname Lastname"),
)

response, _, err := client.PlaidApi.BankTransferCreate(ctx).BankTransferCreateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.BankTransferCreateRequest{
    IdempotencyKey:  "IDEMPOTENCY_KEY",
    AccessToken:     "ACCESS_TOKEN",
    AccountID:       "ACCOUNT_ID",
    Type:            plaid.BankTransferTypeDebit,
    Network:         plaid.BankTransferNetworkAch,
    Amount:          "AMOUNT",
    IsoCurrencyCode: "ISO_CURRENCY_CODE",
    Description:     "DESCRIPTION",
    User:            &plaid.BankTransferUser{LegalName: "Firstname Lastname"},
}

response, err := client.BankTransfer.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transfercancel"
    }}>{`/bank_transfer/cancel`}</h4>
    <Schema method='POST' route='/bank_transfer/cancel' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/cancel' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/cancel \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "bank_transfer_id": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferCancelRequest(bank_transfer_id=bank_transfer_id)
response = client.bank_transfer_cancel(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferCancelRequest = {
  bank_transfer_id,
};
try {
  const response = await plaidClient.bankTransferCancel(request);
  const request_id = response.data.request_id;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferCancelRequest request = new BankTransferCancelRequest()
  .bankTransferId(bankTransferId);
Response<BankTransferCancelResponse> response = client()
  .bankTransferCancel(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferCancelRequest.new({ bank_transfer_id: bank_transfer_id })
response = client.bank_transfer_cancel(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferCancelRequest(
  bankTransferId,
)

response, _, err := client.PlaidApi.BankTransferCancel(ctx).BankTransferCancelRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.BankTransferCancelRequest{BankTransferID: bankTransferId}

response, err := client.BankTransfer.Cancel(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/cancel' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transferget"
    }}>{`/bank_transfer/get`}</h4>
    <Schema method='POST' route='/bank_transfer/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/get \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "bank_transfer_id": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferGetRequest(bank_transfer_id=bank_transfer_id)
response = client.bank_transfer_get(request)
bank_transfer = response['bank_transfer']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferGetRequest = {
  bank_transfer_id,
};
try {
  const response = await plaidClient.bankTransferGet(request);
  const bank_transfer = response.data.bank_transfer;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferGetRequest request = new BankTransferGetRequest()
  .bankTransferId(bankTransferId);
Response<BankTransferGetResponse> response = client()
  .bankTransferGet(request)
  .execute();
BankTransfer bankTransfer =
  response.body().getBankTransfer();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferGetRequest.new({ bank_transfer_id: bank_transfer_id })
response = client.bank_transfer_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferGetRequest(
  bankTransferId,
)

response, _, err := client.PlaidApi.BankTransferGet(ctx).BankTransferGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.BankTransferGetRequest{BankTransferID: bankTransferId}

response, err := client.BankTransfer.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transferlist"
    }}>{`/bank_transfer/list`}</h4>
    <Schema method='POST' route='/bank_transfer/list' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/list \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "start_date": String,
   "end_date": String,
   "count": Number,
   "offset": Number,
   "origination_account_id": String,
   "direction": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferListRequest(
  start_date=start_date,
  end_date=end_date,
  count=count,
  offset=offset,
  origination_account_id=origination_account_id,
  direction=direction,
)
response = client.bank_transfer_list(request)
bank_transfers = response['bank_transfers']
for transfer in bank_transfers:
  # iterate through transfers
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferListRequest = {
  start_date: start_date,
  end_date: end_date,
  count: count,
  offset: offset,
  origination_account_id: origination_account_id,
  direction: direction,
};
try {
  const response = await plaidClient.bankTransferList(request);
  const bank_transfers = response.data.bank_transfers;
  for (const transfer of bank_transfers) {
    // iterate through transfers
  }
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferListRequest request = new BankTransferListRequest()
  .count(count)
  .startDate(startDate)
  .endDate(endDate)
  .offset(offset)
  .originationAccountId(originationAccountId);
Response<BankTransferListResponse> response = client()
  .bankTransferList(request)
  .execute();
List<BankTransfer> transfers =
  response.body().getBankTransfers();
for (BankTransfer bankTransfer : transfers) {
  // iterate through transfers
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferListRequest.new(
  {
    count: count,
    start_date: start_date,
    end_date: end_date,
    offset: offset,
    origination_account_id: origination_account_id,
    direction: direction
  }
)
response = client.bank_transfer_list(request)
response.bank_transfers.each do |bt|
  # iterate through transfers
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferListRequest()
response, _, err := client.PlaidApi.BankTransferList(ctx).BankTransferListRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.BankTransferListRequest{}
response, err := client.BankTransfer.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transfereventlist"
    }}>{`/bank_transfer/event/list`}</h4>
    <Schema method='POST' route='/bank_transfer/event/list' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/event/list' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/event/list \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "start_date": String,
   "end_date": String,
   "bank_transfer_id": String,
   "account_id": String,
   "bank_transfer_type": String,
   "event_types": [String],
   "count": Number,
   "offset": Number,
   "origination_account_id": String,
   "direction": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferEventListRequest(
  start_date=start_date,
  end_date=end_date,
  bank_transfer_id=bank_transfer_id,
  account_id=account_id,
  bank_transfer_type=bank_transfer_type,
  event_types=event_types,
  count=count,
  offset=offset,
  origination_account_id=origination_account_id,
  direction=direction,
)
response = client.bank_transfer_event_list(request)
events = response['bank_transfer_events']
for event in events:
  # iterate through events
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferEventListRequest = {
  start_date: start_date,
  end_date: end_date,
  bank_transfer_id: bank_transfer_id,
  account_id: account_id,
  bank_transfer_type: bank_transfer_type,
  event_types: event_types,
  count: count,
  offset: offset,
  origination_account_id: origination_account_id,
  direction: direction,
};
try {
  const response = await plaidClient.bankTransferEventList(request);
  const events = response.data.bank_transfer_events;
  for (const event of events) {
    // iterate through events
  }
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferEventListRequest request = new BankTransferEventListRequest()
  .bankTransferId(bankTransferId)
  .startDate(startDate)
  .endDate(endDate)
  .accountId(accountId)
  .bankTransferType(bankTransferType)
  .eventTypes(eventTypes)
  .count(count)
  .offset(offset)
  .originationAccountId(originationAccountId)
  .direction(direction);
Response<BankTransferEventListResponse> response = client()
  .bankTransferEventList(request)
  .execute();
List<BankTransferEvent> bankTransferEvents =
  response.body().getBankTransferEvents();
for (BankTransferEvent e : bankTransferEvents) {
  // iterate through events
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferEventListRequest.new(
  {
    start_date: start_date,
    end_date: end_date,
    bank_transfer_id: bank_transfer_id,
    account_id: account_id,
    bank_transfer_type: bank_transfer_type,
    event_types: event_types,
    count: count,
    offset: offset,
    origination_account_id: origination_account_id,
    direction: direction,
  }
)
response = client.bank_transfer_event_list(request)
response.bank_transfer_events.each do |event|
  # iterate through events
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferEventListRequest()
response, _, err := client.PlaidApi.BankTransferEventList(ctx).BankTransferEventListRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    banktransfer "github.com/plaid/plaid-go/v49/banktransfer"
)

request := &banktransfer.BankTransferEventListRequest{}
response, err := client.BankTransfer.Event.List(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/event/list' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transfereventsync"
    }}>{`/bank_transfer/event/sync`}</h4>
    <Schema method='POST' route='/bank_transfer/event/sync' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/event/sync' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/event/sync \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "after_id": Number,
   "count": Number
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferEventSyncRequest(
    after_id=after_id,
    count=count
)
response = client.bank_transfer_event_sync(request)
events = response["bank_transfer_events"]
for event in events:
  # iterate through events
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferEventSyncRequest = {
  after_id: afterID,
  count: 25,
};
try {
  const response = await plaidClient.bankTransferEventSync(request);
  const events = response.data.bank_transfer_events;
  for (const event of events) {
    // iterate through events
  }
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferEventSyncRequest request = new BankTransferEventSyncRequest()
  .afterId(0)
  .count(count);
Response<BankTransferEventSyncResponse> response = client()
  .bankTransferEventSync(request)
  .execute();
List<BankTransferEvent> bankTransferEvents =
  response.body().getBankTransferEvents();
for (BankTransferEvent e : bankTransferEvents) {
  // iterate through events
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferEventSyncRequest.new({ after_id: 0 })
response = client.bank_transfer_event_sync(request)
response.bank_transfer_events.each do |event|
  # iterate through events
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferEventSyncRequest(
  0, // after_id
)
response, _, err := client.PlaidApi.BankTransferEventSync(ctx).BankTransferEventSyncRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    banktransfer "github.com/plaid/plaid-go/v49/banktransfer"
)

request := &banktransfer.BankTransferEventSyncRequest{AfterID: 0} // after_id

response, err := client.BankTransfer.Event.Sync(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/event/sync' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transfermigrate_account"
    }}>{`/bank_transfer/migrate_account`}</h4>
    <Schema method='POST' route='/bank_transfer/migrate_account' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/migrate_account' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/migrate_account \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "account_number": String,
   "routing_number": String,
   "account_type": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferMigrateAccountRequest(
    account_number = '100000000',
    routing_number = '121122676',
    account_type = 'checking'
)
response = client.bank_transfer_migrate_account(request)
access_token = response['access_token']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferMigrateAccountRequest = {
  account_number: '100000000',
  routing_number: '121122676',
  account_type: 'checking',
};
try {
  const response = await plaidClient.bankTransferMigrateAccount(request);
  const access_token = response.data.access_token;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferMigrateAccountRequest request = new BankTransferMigrateAccountRequest()
  .accountNumber("100000000")
  .routingNumber("121122676")
  .accountType("checking");
Response<BankTransferMigrateAccountResponse> response = client()
  .bankTransferMigrateAccount(request)
  .execute();
String accessToken = response.body().getAccessToken();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferMigrateAccountRequest.new(
  {
    account_number: "100000000",
    routing_number: "121122676",
    account_type: "checking",
  }
)
response = client.bank_transfer_migrate_account(request)
access_token = response.access_token
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferMigrateAccountRequest(
  "ACCOUNT_NUMBER", // 100000000
  "ROUTING_NUMBER", // 121122676
  "ACCOUNT_TYPE", // checking
)
response, _, err := client.PlaidApi.BankTransferMigrateAccount(ctx).BankTransferMigrateAccountRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.BankTransferMigrateAccountRequest{
    AccountNumber: "ACCOUNT_NUMBER", // 100000000

    RoutingNumber: "ROUTING_NUMBER", // 121122676

    AccountType: "ACCOUNT_TYPE", // checking
}
response, err := client.BankTransfer.MigrateAccount(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/migrate_account' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "bank_transferbalanceget"
    }}>{`/bank_transfer/balance/get`}</h4>
    <Schema method='POST' route='/bank_transfer/balance/get' type='request' mdxType="Schema">
      <MDXCodeBlock title='/bank_transfer/balance/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/bank_transfer/balance/get \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "origination_account_id": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = BankTransferBalanceGetRequest(
  origination_account_id=origination_account_id,
)
response = client.bank_transfer_balance_get(request)
available_balance = response['balance']['available']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: BankTransferBalanceGetRequest = {
  origination_account_id,
};
try {
  const response = await plaidClient.bankTransferBalanceGet(request);
  const available_balance = response.data.balance.available;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`BankTransferBalanceGetRequest request = new BankTransferBalanceGetRequest()
  .originationAccountId(originationAccountId);
Response<BankTransferBalanceGetResponse> response = client()
  .bankTransferBalanceGet(request)
  .execute();
String availableBalance =
  response.body().getBalance().getAvailable();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::BankTransferBalanceGetRequest.new(
  {
    origination_account_id: origination_account_id
  }
)
response = client.bank_transfer_balance_get(request)
available_balance = response.balance.available
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewBankTransferBalanceGetRequest()
request.SetOriginationAccountId(originationAccountId)
response, _, err := client.PlaidApi.BankTransferBalanceGet(ctx).BankTransferBalanceGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`import (
    banktransfer "github.com/plaid/plaid-go/v49/banktransfer"
)

request := &banktransfer.BankTransferBalanceGetRequest{}
request.OriginationAccountID = &originationAccountId
response, err := client.BankTransfer.Balance.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/bank_transfer/balance/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "sandboxbank_transfersimulate"
    }}>{`/sandbox/bank_transfer/simulate`}</h4>
    <Schema method='POST' route='/sandbox/bank_transfer/simulate' type='request' mdxType="Schema">
      <MDXCodeBlock title='/sandbox/bank_transfer/simulate' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/sandbox/bank_transfer/simulate \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "bank_transfer_id": String,
   "event_type": String,
   "failure_reason": {
     "ach_return_code": String,
     "description": String
   }
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: SandboxBankTransferSimulateRequest = {
  bank_transfer_id,
  event_type: 'posted',
  failure_reason: failureReason,
};
try {
  const response = await plaidClient.sandboxBankTransferSimulate(request);
  // empty response upon success
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = SandboxBankTransferSimulateRequest(
    bank_transfer_id=bank_transfer_id,
    event_type='posted',
    failure_reason=failure_reason
)
response = client.sandbox_bank_transfer_simulate(request)
# empty response upon success
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`SandboxBankTransferSimulateRequest request = new SandboxBankTransferSimulateRequest()
  .bankTransferId(getBankTransfer().getId())
  .eventType("posted");
Response<SandboxBankTransferSimulateResponse> simulateResponse = client()
  .sandboxBankTransferSimulate(request)
  .execute();
// empty response upon success
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::SandboxBankTransferSimulateRequest.new(
  {
    bank_transfer_id: bank_transfer_id,
    event_type: 'posted',
    failure_reason: failure_reason
  }
)
response = client.sandbox_bank_transfer_simulate(request)
# empty response upon success
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewSandboxBankTransferSimulateRequest("BANK_TRANSFER_ID", "posted")
bankTransferSimulateResp, _, err := client.PlaidApi.SandboxBankTransferSimulate(ctx).SandboxBankTransferSimulateRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.SandboxBankTransferSimulateRequest{
    BankTransferID: "BANK_TRANSFER_ID",
    EventType:      "posted",
}
bankTransferSimulateResp, err := client.Sandbox.SimulateBankTransfer(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
  
    </Schema>
    <Schema method='POST' route='/sandbox/bank_transfer/simulate' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "sandboxbank_transferfire_webhook"
    }}>{`/sandbox/bank_transfer/fire_webhook`}</h4>
    <Schema method='POST' route='/sandbox/bank_transfer/fire_webhook' type='request' mdxType="Schema">
      <MDXCodeBlock title='/sandbox/bank_transfer/fire_webhook' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/sandbox/bank_transfer/fire_webhook \\
 -H 'Content-Type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "webhook": String
 }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: SandboxBankTransferFireWebhookRequest = {
  webhook: 'https://www.example.com',
};
try {
  const response = await plaidClient.sandboxBankTransferFireWebhook(request);
  // empty response upon success
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = SandboxBankTransferFireWebhookRequest(
   webhook='https://www.example.com'
)
response = client.sandbox_bank_transfer_fire_webhook(request)
# empty response upon success
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`SandboxBankTransferFireWebhookRequest request = new SandboxBankTransferFireWebhookRequest()
  .webhook("https://www.example.com");
Response<SandboxBankTransferFireWebhookResponse> response = client()
  .sandboxBankTransferFireWebhook(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::SandboxBankTransferFireWebhookRequest.new(
  {
    webhook: 'https://www.example.com'
  }
)
response = client.sandbox_bank_transfer_fire_webhook(request)
# empty response upon success
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewSandboxBankTransferFireWebhookRequest("https://www.example.com/webhook")
bankTransferFireWebhookResp, _, err := client.PlaidApi.SandboxBankTransferFireWebhook(ctx).SandboxBankTransferFireWebhookRequest(
  *request,
).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.SandboxBankTransferFireWebhookRequest{Webhook: "https://www.example.com/webhook"}
bankTransferFireWebhookResp, err := client.Sandbox.FireBankTransferWebhook(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/sandbox/bank_transfer/fire_webhook' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <h4 {...{
      "id": "bank_transfers_events_update"
    }}>{`BANK_TRANSFERS_EVENTS_UPDATE`}</h4>
    <Schema model='BankTransfersEventsUpdateWebhook' type='model' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "bank_transfercreate",
        level: 4,
        title: "/bank_transfer/create",
      },
{
        id: "bank_transfercancel",
        level: 4,
        title: "/bank_transfer/cancel",
      },
{
        id: "bank_transferget",
        level: 4,
        title: "/bank_transfer/get",
      },
{
        id: "bank_transferlist",
        level: 4,
        title: "/bank_transfer/list",
      },
{
        id: "bank_transfereventlist",
        level: 4,
        title: "/bank_transfer/event/list",
      },
{
        id: "bank_transfereventsync",
        level: 4,
        title: "/bank_transfer/event/sync",
      },
{
        id: "bank_transfermigrate_account",
        level: 4,
        title: "/bank_transfer/migrate_account",
      },
{
        id: "bank_transferbalanceget",
        level: 4,
        title: "/bank_transfer/balance/get",
      },
{
        id: "sandboxbank_transfersimulate",
        level: 4,
        title: "/sandbox/bank_transfer/simulate",
      },
{
        id: "sandboxbank_transferfire_webhook",
        level: 4,
        title: "/sandbox/bank_transfer/fire_webhook",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "bank_transfers_events_update",
        level: 4,
        title: "BANK_TRANSFERS_EVENTS_UPDATE",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
